<template>
  <div class="d-flex justify-content-center">
    <div class="spinner-border text-secondary" role="status">
      <span class="sr-only"></span>
    </div>
  </div>
</template>

 <script>

 export default {
   name: 'DashboardLocalPreloader'
 }
 </script>

<style lang="scss" scoped>
</style>